import React from "react";
// import { useSearchParams, useNavigate } from "react-router-dom";
import { Box, Container, Typography, Paper, Stack } from "@mui/material";
// import VaccinationChart from "./VaccinationChart";
// import DynamicHelmet from "./DynamicHelmet";

// basic component that displays a map in an iframe
const MapPage: React.FC = () => {
  // const [searchParams] = useSearchParams();
  // const navigate = useNavigate();
  // const schoolName = searchParams.get("schoolName") || "";

  // const handleGoBack = () => {
  //   navigate("/");
  // };

  return (
    <Container maxWidth="lg" sx={{ py: 4 }}>
      <Paper elevation={3} sx={{ p: 4 }}>
        <Stack spacing={3}>
          <Typography variant="h4" component="h1" align="center" gutterBottom>
            MMR and Full Vaccination Rates in California Kindergartens
          </Typography>

          <Typography variant="body1">
            This interactive map shows kindergartners' vaccination rates at more
            than 6,000 public and private schools across California. According
            to the state health department, at least 95% of students need the
            MMR (measles, mumps, rubella) vaccine to maintain herd immunity and
            prevent outbreaks. Yet in many parts of the state—including areas
            around Sacramento, Oakland, the Central Valley, and Los
            Angeles—vaccination rates fall short of that threshold, raising
            concerns about community vulnerability.
          </Typography>

          <Box
            component="iframe"
            src="https://edsource.org/dataviz/2023_24Vaxmapforkindergartners_416/"
            width="100%"
            height="900px"
            sx={{ border: "none" }}
          />

          <Typography variant="body2" color="text.secondary" align="center">
            Data source: California Department of Public Health and EdSource
            Analysis
          </Typography>
        </Stack>
      </Paper>
    </Container>
  );
};
// export default MapPage;
export default MapPage;
